// @flow

import { notification } from "antd"

export const copyToClipboard = (text: string) => {
  const dummy = document.createElement("textarea")
  if (document.body) {
    document.body.appendChild(dummy)
  }
  dummy.value = text
  dummy.select()
  document.execCommand("copy")
  if (document.body) {
    document.body.removeChild(dummy)
  }
}

export const onCopyLinkClicked = (message: string, path: string) => {
  copyToClipboard(path)
  notification.success({ message })
}
